/* eslint-disable no-param-reassign */
import axios from 'axios'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import type { FetchStatusCommon } from '../../../restApi/types'
import type { RestEditListingFormData } from './useFormCompletionEndpoint'

type AxiosData = { data: RestEditListingFormData }
type RejectError = Error
type ListingId = string
type ThunkAPI = {
  rejectValue: RejectError
}

export const fetchFormCompletionData = createAsyncThunk<
  AxiosData,
  ListingId,
  ThunkAPI
>('MY_LISTING_FORM_COMPLETION_FETCH', async (listingId) => {
  try {
    const payload = await axios.get<RestEditListingFormData>(
      `/user/listings/${listingId}/forms`,
    )
    return payload
  } catch (error) {
    return error
  }
})

type FormCompletionState = FetchStatusCommon & {
  data: RestEditListingFormData
}

const initialState: FormCompletionState = {
  data: [],
  fetching: false,
  fetched: false,
  updating: false,
  updated: false,
  submitting: false,
  error: null,
}

export const formCompletionSlice = createSlice({
  name: 'myListingFormCompletion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFormCompletionData.pending, (state) => {
      state.fetching = true
    })

    builder.addCase(fetchFormCompletionData.rejected, (state, action) => {
      state.error = action.payload
      state.fetching = false
    })

    builder.addCase(fetchFormCompletionData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.fetched = true
      state.fetching = false
    })
  },
})

export default formCompletionSlice.reducer
